import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle, Lightbulb, Repeat } from 'lucide-react';
import { InteriorSlide, SlideHeader, SlideBanner } from './SlideShell';
import type { SlideProps } from './SlideShell';
export function Slide02ExecSummary({
  index
}: SlideProps) {
  const cards = [{
    icon: AlertCircle,
    title: 'The challenge',
    text: 'HCP attention is harder to win with static digital formats.',
    delay: 0.4
  }, {
    icon: Lightbulb,
    title: 'The opportunity',
    text: 'Amoxil already has strong content and brand relevance.',
    delay: 0.55
  }, {
    icon: Repeat,
    title: 'The solution',
    text: 'Reusable master assets with monthly interactive campaign adaptations.',
    delay: 0.7
  }];
  return <InteriorSlide surface banner={<SlideBanner eyebrow="The Goal" data-id="element-58">
          Turn monthly Amoxil campaigns into short, interactive experiences that
          capture attention, increase engagement, and generate behavioral
          insights.
        </SlideBanner>} data-id="element-57">
      <SlideHeader eyebrow="Executive Summary" data-id="element-59">
        Revitalizing Amoxil engagement through interactive digital campaigns
      </SlideHeader>

      <div className="flex-1 flex flex-col justify-center max-w-6xl mx-auto w-full" data-id="element-60">
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3,
        duration: 0.6
      }} className="text-[clamp(1.1rem,1.5vw,1.4rem)] text-[var(--muted)] leading-relaxed mb-12 max-w-4xl" data-id="element-61">
          Amoxil is a key legacy brand promoted 100% digitally. Existing digital
          communication is strong, but HCP engagement is declining. Snakker can
          help GSK Morocco turn monthly Amoxil campaigns into short, interactive
          experiences that capture attention, increase engagement, and generate
          behavioral insights.
        </motion.p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8" data-id="element-62">
          {cards.map((card, i) => {
          const Icon = card.icon;
          return <motion.div key={card.title} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: card.delay,
            duration: 0.6
          }} className="bg-white rounded-2xl p-8 shadow-sm border border-black/5 relative overflow-hidden group" data-id="element-63">
                <div className="absolute top-0 right-0 w-32 h-32 bg-[var(--brand)]/5 rounded-bl-full -mr-16 -mt-16 transition-transform group-hover:scale-110" data-id="element-64" />
                <div className="h-12 w-12 rounded-xl bg-[var(--surface)] flex items-center justify-center mb-6 text-[var(--brand)]" data-id="element-65">
                  <Icon className="h-6 w-6" data-id="element-66" />
                </div>
                <h3 className="text-xl font-bold text-[var(--fg)] mb-3" data-id="element-67">
                  {card.title}
                </h3>
                <p className="text-[var(--muted)] leading-relaxed" data-id="element-68">
                  {card.text}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </InteriorSlide>;
}